import { Component, Input, ViewChild } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DrawerComponent } from './components/drawer/drawer.component';
@Component({
  template: '',
  standalone: false,
})
export class TextbookActionBase<T> {
  @ViewChild(DrawerComponent) drawerComponent!: DrawerComponent;

  protected _action!: T;
  get action(): T {
    return this._action;
  }
  @Input() set action(value: T) {
    this._action = value;
  }

  canDeactivate(): Observable<boolean> {
    if (this.drawerComponent) {
      return this.drawerComponent.canDeactivate();
    }
    return of(true);
  }
}
